import { render, staticRenderFns } from "./WorkingPreciousMetalsStonesAddEdit.vue?vue&type=template&id=3d98239d&scoped=true&"
import script from "./WorkingPreciousMetalsStonesAddEdit.vue?vue&type=script&lang=js&"
export * from "./WorkingPreciousMetalsStonesAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./WorkingPreciousMetalsStonesAddEdit.vue?vue&type=style&index=0&id=3d98239d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d98239d",
  null
  
)

export default component.exports